var _path, _path2, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEspejo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 29,
    viewBox: "0 0 37 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.11125 4.38791L15.0429 14.5L5.11125 24.6121V4.38791Z",
    fill: "#ECEDEA",
    stroke: "#ECEDEA",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8888 4.38791L21.9571 14.5L31.8888 24.6121V4.38791Z",
    fill: "#ECEDEA",
    stroke: "#ECEDEA",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 18.8147,
    y1: 3.22217,
    x2: 18.8147,
    y2: 26.5833,
    stroke: "#ECEDEA",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEspejo);
export default __webpack_public_path__ + "static/media/espejo.6520cd7ae4b250c5c5c5d2b34219ace1.svg";
export { ForwardRef as ReactComponent };